module.exports = __webpack_public_path__ + "io.aecf8a97.svg";